import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
          Copyright © IDIX Consulting 2026
        </p>
      </div>
    </footer>
  );
};

export default Footer;
